import type { ItemResponse } from "@memorang/types/src/session/new-session";
import { helpDialog } from "./dialog-configs";

const variatTitleMap = {
	MCQ: "Multiple-Choice Question",
	SATA: "Multiple-Response Question",
	CST: "CST",
	writing: "Writing Prompt",
	listening: "Listening Prompt",
	speaking: "Speaking Prompt",
	readingprose: "Reading Prose",
	readingdocuments: "Reading Chart",
	hotspot: "Hotspots",
	quantitative: "Quantitative",
	emailwriting: "email",
	essayGrading: "Essay Grading",
	audioResponse: "Audio Response",
	sequence: "Sequence",
	textAnswer: "Text Answer",
	audioAnswer: "Audio Answer",
	markingAnswer: "Marking Answer",
	vocabulary: "Vocabulary",
	reading: "Reading",
	WRITING: "Writing",
};

export const sessionMaxWidth = {
	summative: 960,
	formative: 840,
};

export const isAiSubmittable = (responseType: ItemResponse["type"]) => {
	return (
		responseType === "form" ||
		responseType === "recording" ||
		responseType === "writing"
	);
};

const stimulusIconMap = {
	READING: "book-open-page-variant-outline" as const,
	WRITING: "file-document-edit-outline" as const,
	LISTENING: "ear-hearing" as const,
	SPEAKING: "microphone-outline" as const,
	IMAGE: "image-outline" as const,
};

// Render above the bottom app bar + some padding
export const FAB_BOTTOM_POSITION = 80 + 24;

export { variatTitleMap, helpDialog, stimulusIconMap };
